
import { Component, Prop, Vue } from "vue-property-decorator";
import { Mutation } from "vuex-class";

@Component
export default class Stars extends Vue {
  @Prop() private level!: number;
}

